import { gql } from 'apollo-angular';

export const RemoveTacticMetricDocument = gql`
  mutation removeTacticMetric($id: Int!) {
    removeTacticMetric(id: $id)
  }
`;
